export abstract class MegaraxError extends Error {}

export class EntityNotFoundError extends MegaraxError {
  name = "EntityNotFoundError";
}

export class MultipleEntitiesFoundError extends MegaraxError {
  name = "MultipleEntitiesFoundError";
}

export class PermissionDeniedError extends MegaraxError {
  name = "PermissionDeniedError";
  message = "You do not have sufficient privilege to perform this operation.";
}

export class InvalidOperationError extends MegaraxError {
  name = "InvalidOperationError";
}

export class EntityAlreadyExistsError extends InvalidOperationError {
  name = "EntityAlreadyExistsError";
}

export class ServiceNotFoundError extends MegaraxError {
  name = "ServiceNotFoundError";
}
